import { createAsyncThunk } from "@reduxjs/toolkit"
import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios"

interface UsersStatisticPayload {}

interface UsersStatisticsResponse {}

export interface UserStatisticsData {
	bankId: string
	corporateSenderId: string
	enabled: number
	disabled: number
	totalUser: number
	userWithFailedLogin: number
	neverLogged: number
}

export interface FileStatisticsData {
	bankId: string
	corporateSenderId: string
	totalFiles: number
	totalAmount: number
	plicksCount: number
	drafts: number
	errors: number
}

export interface UserStatisticsState {
	isLoading: boolean
	data: UserStatisticsData[] | undefined
	error: string | undefined
}

export interface FileStatisticsState {
	isLoading: boolean
	data: FileStatisticsData[] | undefined
	error: string | undefined
}

export interface StatisticsState {
	file: FileStatisticsState
	user: UserStatisticsState
}

export const getFileStatistics = createAsyncThunk(
	"statistics/getFileStatistics",
	async () => {
		try {
			const config: AxiosRequestConfig = {
				headers: {
					"Content-Type": "application/json",
				},
				withCredentials: true,
			}

			const baseUrl = `${process.env.REACT_APP_FILE_SERVICE_API_URL}/fileservice/apistatistics/v2/getFileStatistics`
			const response: AxiosResponse<FileStatisticsData[]> = await axios.get(
				`${baseUrl}`,
				config
			)

			return response.data
		} catch (error) {
			const axiosError = error as AxiosError<string>
			// return rejectWithValue(axiosError?.response?.data ?? { message: 'error.generic' });
		}
	}
)

export const getUserStatistics = createAsyncThunk(
	"statistics/getUserStatistics",
	async () => {
		try {
			const config: AxiosRequestConfig = {
				headers: {
					"Content-Type": "application/json",
				},
				withCredentials: true,
			}

			const baseUrl = `${process.env.REACT_APP_USER_MANAGEMENT_API_URL}/userservice/apistatistics/v2/getUserStatistics`
			const response: AxiosResponse<UserStatisticsData[]> = await axios.get(
				`${baseUrl}`,
				config
			)

			return response.data
		} catch (error) {
			const axiosError = error as AxiosError<string>
			// return rejectWithValue(axiosError?.response?.data ?? { message: 'error.generic' });
		}
	}
)
